import type { DemoProjectUsage, OrganizationRole, ProjectAccessScope } from '@dashboard/types/organization'

const ROLE_LABELS: Record<OrganizationRole, string> = { owner: 'Owner', admin: 'Admin', member: 'Member' }

export const organizationRoleLabel = (role: OrganizationRole): string => ROLE_LABELS[role]

export const projectAccessLabel = (scope: ProjectAccessScope): string =>
  scope === 'all' ? 'All projects' : 'Selected projects'

export const demoProjectsText = ({ used, limit }: DemoProjectUsage): string =>
  `${used} of ${limit} demo ${limit === 1 ? 'project' : 'projects'}`
